import {
    LOAD_PROJECT_LIST,
    LOAD_PROJECT_LIST_SUCCESS,
    SAVE_PROJECT_ID,
} from 'constants/ActionTypes';


export const loadProjects = (user_id) => {
    return {
      type: LOAD_PROJECT_LIST,
      payload: user_id
    };
  };

  export const loadProjectListSuccess = (projects) => {
    return {
      type: LOAD_PROJECT_LIST_SUCCESS,
      payload: projects
    }
  };

  export const saveProjectID = (projectID) => {
    return {
      type: SAVE_PROJECT_ID,
      payload: projectID
    }
  };